import * as actionTypes from '../action';

const initialState = {
    sessionError: false,
    supervisorLoader: false,
    supervisorError: false,
    dataLoadError: false,
    issuerConfigLoader: false,
    issuerConfig: {},
    supervisor: [],
    supervisorListLoader: false,
    supervisorList: [],
    statsDataLoader: false,
    statsData: {},
    exchangeRateLoader: false,
    exchangeRateList: [],
    clientLoader: false,
    clientList: [],
    client: {},
    trancheListLoader: false,
    trancheList: [],
    agathaConfigListLoader: false,
    agathaConfigList: [],
    agathaBalanceLoader: false,
    agathaBalance: {},
    transactionLoader: false,
    transactionList: [],
    transaction: {},
    executionLoader: false,
    executionList: [],
    supervisorLoginLoader: false,
    supervisorLoginList: [],
    supervisorActionLoader: false,
    supervisorActionLogList: [],
    supervisorActionLog: {},
    vfaspAccessRightsLoader: false,
    vfaspAccessRightsList: [],
    defaultAccessRightList: [],
    defaultAccessRightLoader: false,
    supervisorAccessRightList: [],
    supervisorAccessRightLoader: false
};

const remoteReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SUPERVISOR_SESSION_ERROR:
            return { ...state, sessionError: action.payload };
        case actionTypes.DATALOAD_ERROR:
            return { ...state, dataLoadError: action.payload };
        case actionTypes.ISSUERCONFIG_DATA_LOADING:
            return { ...state, issuerConfigLoader: action.payload };
        case actionTypes.ISSUERCONFIG_DATA_SUCCESS:
            return { ...state, issuerConfig: action.payload };
        case actionTypes.SUPERVISOR_DATA_LOADING:
            return { ...state, supervisorLoader: action.payload };
        case actionTypes.SUPERVISOR_DATA_SUCCESS:
            return { ...state, supervisor: action.payload };
        case actionTypes.SUPERVISORLIST_DATA_LOADING:
            return { ...state, supervisorListLoader: action.payload };
        case actionTypes.SUPERVISORLIST_DATA_SUCCESS:
            return { ...state, supervisorList: action.payload };
        case actionTypes.STATS_DATA_LOADING:
            return { ...state, statsDataLoader: action.payload };
        case actionTypes.STATS_DATA_SUCCESS:
            return { ...state, statsData: action.payload };
        case actionTypes.EXCHANGERATE_DATA_LOADING:
            return { ...state, exchangeRateLoader: action.payload };
        case actionTypes.EXCHANGERATE_DATA_SUCCESS:
            return { ...state, exchangeRateList: action.payload };
        case actionTypes.CLIENTLIST_DATA_LOADING:
            return { ...state, clientLoader: action.payload };
        case actionTypes.CLIENTLIST_DATA_SUCCESS:
            return { ...state, clientList: action.payload };
        case actionTypes.CLIENT_DATA_LOADING:
            return { ...state, clientLoader: action.payload };
        case actionTypes.CLIENT_DATA_SUCCESS:
            return { ...state, client: action.payload };
        case actionTypes.TRANCHE_DATA_LOADING:
            return { ...state, trancheListLoader: action.payload };
        case actionTypes.TRANCHE_DATA_SUCCESS:
            return { ...state, trancheList: action.payload };
        case actionTypes.AGATHACONFIG_DATA_LOADING:
            return { ...state, agathaConfigListLoader: action.payload };
        case actionTypes.AGATHACONFIG_DATA_SUCCESS:
            return { ...state, agathaConfigList: action.payload };
        case actionTypes.TRANSACTIONLIST_DATA_LOADING:
            return { ...state, transactionLoader: action.payload };
        case actionTypes.TRANSACTIONLIST_DATA_SUCCESS:
            return { ...state, transactionList: action.payload };
        case actionTypes.TRANSACTION_DATA_LOADING:
            return { ...state, transactionLoader: action.payload };
        case actionTypes.TRANSACTION_DATA_SUCCESS:
            return { ...state, transaction: action.payload };
        case actionTypes.EXECUTIONLIST_DATA_LOADING:
            return { ...state, executionLoader: action.payload };
        case actionTypes.EXECUTIONLIST_DATA_SUCCESS:
            return { ...state, executionList: action.payload };
        case actionTypes.EXECUTION_DATA_LOADING:
            return { ...state, executionLoader: action.payload };
        case actionTypes.SUPERVISORLOGINLIST_DATA_LOADING:
            return { ...state, supervisorLoginLoader: action.payload };
        case actionTypes.SUPERVISORLOGINLIST_DATA_SUCCESS:
            return { ...state, supervisorLoginList: action.payload };
        case actionTypes.SUPERVISORACTIONLIST_DATA_LOADING || actionTypes.SUPERVISORACTION_DATA_LOADING:
            return { ...state, supervisorActionLoader: action.payload };
        case actionTypes.SUPERVISORACTIONLIST_DATA_SUCCESS:
            return { ...state, supervisorActionLogList: action.payload };
        case actionTypes.SUPERVISORACTION_DATA_SUCCESS:
            return { ...state, supervisorActionLog: action.payload };
        case actionTypes.VFASPACCESSRIGHTSLIST_DATA_LOADING:
            return { ...state, vfaspAccessRightsLoader: action.payload };
        case actionTypes.VFASPACCESSRIGHTSLIST_DATA_SUCCESS:
            return { ...state, vfaspAccessRightsList: action.payload };
        case actionTypes.DEFAULTACCESSRIGHTSLIST_DATA_LOADING:
            return { ...state, defaultAccessRightLoader: action.payload };
        case actionTypes.DEFAULTACCESSRIGHTSLIST_DATA_SUCCESS:
            return { ...state, defaultAccessRightList: action.payload };
        case actionTypes.SUPERVISORACCESSRIGHTSLIST_DATA_LOADING:
            return { ...state, supervisorAccessRightLoader: action.payload };
        case actionTypes.SUPERVISORACCESSRIGHTSLIST_DATA_SUCCESS:
            return { ...state, supervisorAccessRightList: action.payload };
        default:
            return state;
    }
};
export default remoteReducer;
